// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let RescriptRelayReact = require("rescript-relay/src/RescriptRelayReact.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let PropertyWizardRelayPreviewQuery_graphql = require("../../../__generated__/PropertyWizardRelayPreviewQuery_graphql.bs.js");

let convertVariables = PropertyWizardRelayPreviewQuery_graphql.Internal.convertVariables;

let convertResponse = PropertyWizardRelayPreviewQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = PropertyWizardRelayPreviewQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, PropertyWizardRelayPreviewQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, PropertyWizardRelayPreviewQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(PropertyWizardRelayPreviewQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(PropertyWizardRelayPreviewQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(PropertyWizardRelayPreviewQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(PropertyWizardRelayPreviewQuery_graphql.node, convertVariables);

let Query_forSalePropertyTypeEnumV5_decode = PropertyWizardRelayPreviewQuery_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let Query_forSalePropertyTypeEnumV5_fromString = PropertyWizardRelayPreviewQuery_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let Query_leaseLengthValue_decode = PropertyWizardRelayPreviewQuery_graphql.Utils.leaseLengthValue_decode;

let Query_leaseLengthValue_fromString = PropertyWizardRelayPreviewQuery_graphql.Utils.leaseLengthValue_fromString;

let Query_lotSizeUnit_decode = PropertyWizardRelayPreviewQuery_graphql.Utils.lotSizeUnit_decode;

let Query_lotSizeUnit_fromString = PropertyWizardRelayPreviewQuery_graphql.Utils.lotSizeUnit_fromString;

let Query_mlsListingTypeV5_decode = PropertyWizardRelayPreviewQuery_graphql.Utils.mlsListingTypeV5_decode;

let Query_mlsListingTypeV5_fromString = PropertyWizardRelayPreviewQuery_graphql.Utils.mlsListingTypeV5_fromString;

let Query_rentalPropertyTypeEnumV5_decode = PropertyWizardRelayPreviewQuery_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let Query_rentalPropertyTypeEnumV5_fromString = PropertyWizardRelayPreviewQuery_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let Query_showingTypeV5_decode = PropertyWizardRelayPreviewQuery_graphql.Utils.showingTypeV5_decode;

let Query_showingTypeV5_fromString = PropertyWizardRelayPreviewQuery_graphql.Utils.showingTypeV5_fromString;

let Query = {
  forSalePropertyTypeEnumV5_decode: Query_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: Query_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: Query_leaseLengthValue_decode,
  leaseLengthValue_fromString: Query_leaseLengthValue_fromString,
  lotSizeUnit_decode: Query_lotSizeUnit_decode,
  lotSizeUnit_fromString: Query_lotSizeUnit_fromString,
  mlsListingTypeV5_decode: Query_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: Query_mlsListingTypeV5_fromString,
  rentalPropertyTypeEnumV5_decode: Query_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: Query_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: Query_showingTypeV5_decode,
  showingTypeV5_fromString: Query_showingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function usePreloadPreviewQuery() {
  let environment = RescriptRelayReact.useEnvironmentFromContext();
  return propertyData => fetch(environment, {
    propertyData: propertyData
  }, result => {}, undefined, undefined);
}

exports.Query = Query;
exports.usePreloadPreviewQuery = usePreloadPreviewQuery;
/* use Not a pure module */
